import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=194bc013&scoped=true&"
import script from "./NewProjectModal.vue?vue&type=script&lang=js&"
export * from "./NewProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194bc013",
  null
  
)

export default component.exports